const o = {
  parts: ["qtyBtn", "atc", "qtySelector"],
  baseStyle: ({ theme: a }) => ({
    atc: {
      paddingX: a.atcPaddingHorizontal,
      paddingY: a.atcPaddingVertical,
      backgroundColor: a.atc.backgroundDefault,
      color: a.atc.onDefault,
      border: `1px solid ${a.atc.borderDefault}`,
      _hover: {
        backgroundColor: a.atc.backgroundPressed,
        color: a.atc.onPressed,
        _disabled: {
          backgroundColor: a.atc.disabled
        }
      },
      _focus: {
        backgroundColor: a.atc.backgroundDefault,
        color: a.atc.onDefault
      },
      _active: {
        backgroundColor: a.atc.backgroundDefault,
        color: a.atc.onDefault,
        border: `1px solid ${a.atc.borderDefault}`
      },
      _disabled: {
        backgroundColor: a.atc.disabled,
        border: "none",
        color: a.atc.onDisabled
      }
    },
    qtyBtn: {
      backgroundColor: "transparent",
      padding: 0,
      color: a.atc.onPressed,
      _hover: {
        backgroundColor: "transparent"
      },
      _focus: {
        color: a.atc.onPressed,
        backgroundColor: a.atc.backgroundPressed,
        border: `1px solid ${a.atc.onPressed}`,
        borderRadius: a.form.borderRadius
      },
      _active: {
        background: "transparent"
      },
      _disabled: {
        color: a.icon.disabled,
        background: "transparent"
      }
    },
    qtySelector: {
      paddingX: a.atcPaddingHorizontal,
      paddingY: a.atcPaddingVertical,
      backgroundColor: a.atc.backgroundPressed,
      color: a.atc.onPressed,
      border: `1px solid ${a.atc.borderPressed}`,
      _focus: {
        paddingX: a.atcPaddingHorizontal,
        paddingY: a.atcPaddingVertical,
        backgroundColor: a.atc.backgroundPressed,
        border: `1px solid ${a.atc.borderPressed}`
      }
    }
  }),
  variants: {
    compact: ({ theme: a }) => ({
      atc: {
        borderRadius: a.atcBorderRadius,
        minWidth: 10
      },
      qtySelector: {
        minWidth: 10,
        borderRadius: a.atcBorderRadius,
        _focus: {
          borderRadius: a.atcBorderRadius
        }
      }
    }),
    full: ({ theme: a }) => ({
      atc: {
        borderRadius: a.atcBorderRadiusFull,
        minWidth: {
          base: "100%",
          xsm: a.atc.buttonMaxWidth
        }
      },
      qtySelector: {
        borderRadius: a.atcBorderRadiusFull,
        minWidth: {
          base: "100%",
          xsm: a.atc.buttonMaxWidth
        }
      }
    })
  }
};
export {
  o as default
};
